// Version : 1.0.0
// Author : AGALYA

const PhotoVerificationActionType = {
	/** ***************** Member Photo Add Start ************************/
	ADD_MEMBER_PHOTO_START: 'add_member_photo_start',
	ADD_MEMBER_PHOTO_SUCCESS: 'add_member_photo_success',
	ADD_MEMBER_PHOTO_FAILURE: 'add_member_photo_failure',
	ADD_MEMBER_PHOTO_RESPONSE_REST_START: 'add_member_photo_response_reset_start',
	ADD_MEMBER_PHOTO_RESPONSE_CHANGED: 'add_member_photo_response_changed',
	/** ***************** Member Photo Add End ************************/
};

export default PhotoVerificationActionType;
